import { render, staticRenderFns } from "./workspace-delete-option-modal.vue?vue&type=template&id=7bf8117d&"
import script from "./workspace-delete-option-modal.vue?vue&type=script&lang=js&"
export * from "./workspace-delete-option-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports